import React from 'react';

import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModuleController} from "../game-center-header-module.controller";
import styles from "../styles/game-center-header.module.scss"
import classNames from "classnames";

export class GameCenterHeaderModuleSeriesIndicationProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleSeriesIndication = ({controller}: GameCenterHeaderModuleSeriesIndicationProps) => {
  const {state} = controller;
  const {shouldRenderSeriesIndication, seriesScoreText} = state;

  return (
    shouldRenderSeriesIndication ? <div className={classNames(styles.bottom_status)}>
      {seriesScoreText}
    </div> : null
  )
};
